import Providers from 'providers';

import Intake from './Intake';
import { AntdOverrides, GlobalStyles } from './IntakeApp.styled';

export default function SpecialistApp() {
  return (
    <Providers>
      <Intake />
      <AntdOverrides />
      <GlobalStyles />
    </Providers>
  );
}
